import { defaultFeatureFlags } from "./account/constants/feature-flags";

const initialSeason = 2023;
const currentSeason = new Date().getFullYear();

export default defineAppConfig({
  useMVP: true,
  useMockData: false,
  debugPano: false,
  currentSeason: currentSeason,
  currentCrossSeason: currentSeason - 1,
  availableSeasons: Array.from({ length: currentSeason - initialSeason + 1 }, (_, i) => initialSeason + i),
  /**
   * Load features from the server.
   * If set to false, the app will use the default feature flags without API call and replacement of those from the server.
   */
  loadFeatures: true,
  features: defaultFeatureFlags,
});
